export const ELVARLI = "elvarli";
